export const formsJson = {
  login: {
    emp: {
      columns: {
        userName: {
          type: "text",
          legend: "user name",
          other: {
            autoComplete: "off",
            placeholder: "user name or mail"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        pass: {
          type: "password",
          legend: "password",
          other: {
            placeholder: "password"
          },
          fldAttr: {
            className: [
              "wideFieldset",
              "mrgbViewPass"
            ]
          }
        },
        captcha: {
          type: "captcha",
          legend: "security code",
          other: {
            placeholder: "security code",
            inputMode: "numeric"
          },
          fldAttr: {
            className: [
              "captchaFieldset"
            ]
          }
        },
        remember: {
          type: "mrbgCheckBox",
          label: "remember me",
          other: {
            value: 1
          },
          fldAttr: {
            className: [
              "rememberMeCheckbox"
            ]
          }
        },
        token: {
          type: "text",
          legend: "token",
          other: {
            placeholder: "token"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        newPass: {
          type: "password",
          legend: "new password",
          other: {
            autoComplete: "new-password",
            placeholder: "new password"
          },
          fldAttr: {
            className: [
              "wideFieldset",
              "mrgbViewPass"
            ]
          }
        },
        oldPass: {
          type: "password",
          legend: "old password",
          other: {
            autoComplete: "new-password",
            placeholder: "old password"
          },
          fldAttr: {
            className: [
              "wideFieldset",
              "mrgbViewPass"
            ]
          }
        }
      },
      forms: {
        signIn: {
          operation: "sIE",
          inputs: {
            userName: {},
            pass: {},
            captcha: {},
            remember: {}
          },
          msg: true,
          btn: {
            label: "sign In",
            "class": "signIn"
          }
        },
        forgotPassToken: {
          operation: "EGT",
          inputs: {
            userName: {}
          },
          msg: true,
          btn: {
            label: "get token",
            "class": "confirm"
          }
        },
        resetPass: {
          operation: "ERP",
          inputs: {
            token: {},
            newPass: {}
          },
          msg: true,
          btn: {
            label: "reset password",
            "class": "confirm"
          }
        },
        unsecurePass: {
          operation: "ECP",
          inputs: {
            oldPass: {},
            newPass: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        }
      },
      tables: []
    }
  },
  AP: {
    con: {
      columns: {
        pagID: {
          type: "mrbgSelect",
          label: "برگزیدن صفحه",
          firstOptLabel: "برگزیدن صفحه",
          optVarName: "pag__ST"
        },
        type: {
          type: "mrbgSelect",
          label: "محل قرار گرفتن عکس",
          firstOptLabel: "برگزیدن نوع محتوا",
          optVarName: "conType__ST"
        },
        title: {
          type: "text",
          label: "عنوان",
          other: {
            maxLength: 512,
            placeholder: "title"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        img: {
          type: "mrbgImgFile",
          label: "برگزیدن عکس",
          other: {
            placeholder: "image",
            accept: "image/bmp,image/gif,image/jpeg,image/pjpeg,image/png,image/webp",
            "data-height": 506,
            "data-width": 900
          },
          fldAttr: {}
        },
        alt: {
          type: "text",
          label: "توضیحات عکس @@(برای بهینه سازی گوگل)@@",
          other: {
            maxLength: 1023,
            placeholder: "image's description"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        description: {
          type: "mrbgTE",
          label: "متن",
          other: {
            imgheight: 360,
            imgwidth: 640
          },
          fldAttr: {
            className: [
              "frameMrbgTextEditor"
            ]
          }
        },
        id: {
          type: "mrbgSelect",
          label: "برگزیدن محتوا",
          firstOptLabel: "برگزیدن محتوا",
          optVarName: "con__ST"
        },
        updatedAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ به‌روزرسانی",
          other: []
        },
        createdBy: {
          type: "mrbgSelect",
          label: "ایجاد شده توسط",
          firstOptLabel: "ایجاد شده توسط",
          optVarName: "empUser__ST"
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ درج",
          other: []
        }
      },
      forms: {
        con: {
          title: "افزودن محتوا",
          operation: "ins",
          inputs: {
            pagID: {},
            type: {},
            title: {},
            img: {},
            alt: {},
            description: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        conSrt: {
          title: "ترتیب محتوا",
          operation: "srt",
          hierarchicalList: "con__SL",
          inputs: {
            pagID: {}
          },
          msg: true,
          btn: {
            label: "change",
            "class": "change"
          }
        }
      },
      tables: {
        con__TF: {
          tblID: "con__TB",
          title: "لیست محتوا",
          operation: "",
          filters: {
            id: {},
            pagID: {},
            type: {},
            title: {},
            alt: {},
            updatedAt: {},
            createdBy: {},
            createdAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: true,
          columns: {
            name: "نام",
            type: "نوع",
            title: "",
            description: "توضیحات",
            img: "عکس",
            alt: "توضیحات عکس",
            createdBy: "",
            updatedBy: "آخرین ویرایش توسط",
            createdAt: "تاریخ ایجاد",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          msg: true
        }
      }
    },
    fot: {
      columns: {
        role: {
          type: "hidden",
          other: {
            value: "social media"
          }
        },
        icon: {
          type: "mrbgSelect",
          label: "آیکون برای شبکه‌های اجتماعی",
          firstOptLabel: "برگزیدن یک آیکون برای شبکه‌های اجتماعی",
          optVarName: "icn__ST",
          iconMode: true
        },
        connection: {
          type: "url",
          label: "لینک",
          other: {
            maxLength: 128,
            placeholder: "link"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        }
      },
      forms: {
        address: {
          title: "آدرس در فوتر",
          operation: "cnt",
          inputs: {
            role: {},
            icon: {}
          },
          parts: {
            adr: {
              subTitle: "آدرس",
              repeat: 1,
              inputs: {
                connection: {}
              }
            }
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        phone: {
          title: "شماره تلفن در فوتر",
          operation: "cnt",
          inputs: {
            role: {},
            icon: {}
          },
          parts: {
            number: {
              subTitle: "شماره تلفن",
              repeat: 1,
              inputs: {
                connection: {}
              }
            }
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        mobile: {
          title: "شماره موبایل در فوتر",
          operation: "cnt",
          inputs: {
            role: {},
            icon: {}
          },
          parts: {
            number: {
              subTitle: "شماره موبایل",
              repeat: 1,
              inputs: {
                connection: {}
              }
            }
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        socialMedia: {
          title: "شبکه‌های اجتماعی در فوتر",
          operation: "sMd",
          inputs: {
            role: {}
          },
          parts: {
            media: {
              subTitle: "شبکه‌های اجتماعی",
              repeat: 1,
              inputs: {
                icon: {},
                connection: {}
              }
            }
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        }
      },
      tables: {
        fot__TF: {
          tblID: "fot__TB",
          title: "لیست اطلاعات فوتر",
          operation: "",
          filters: [],
          rowsCol: true,
          pencil: true,
          trash: true,
          columns: {
            icon: "آیکون",
            connection: "ارتباط",
            createdBy: "ایجاد شده توسط",
            createdAt: "تاریخ ایجاد",
            updatedBy: "آخرین ویرایش توسط",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          msg: true
        }
      }
    },
    gal: {
      columns: {
        pagID: {
          type: "mrbgSelect",
          label: "برگزیدن صفحه",
          firstOptLabel: "برگزیدن صفحه",
          optVarName: "pag__ST"
        },
        title: {
          type: "text",
          label: "عنوان",
          other: {
            maxLength: 128,
            placeholder: "title"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        img: {
          type: "mrbgImgFile",
          label: "برگزیدن عکس",
          other: {
            placeholder: "image's description",
            accept: "image/bmp,image/gif,image/jpeg,image/pjpeg,image/png,image/webp",
            "data-height": 500,
            "data-width": 500
          },
          fldAttr: {}
        },
        alt: {
          type: "text",
          label: "توضیحات عکس @@(for search engine optimization)@@",
          other: {
            maxLength: 512,
            placeholder: "image's description"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        url: {
          type: "text",
          label: "آدرس اینترنتی",
          other: {
            maxLength: 64,
            placeholder: "url"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        }
      },
      forms: {
        gal: {
          title: "افزودن عکس گالری",
          operation: "ins",
          inputs: {
            pagID: {},
            title: {},
            img: {},
            alt: {},
            url: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        }
      },
      tables: []
    },
    hedLin: {
      columns: {
        parentID: {
          type: "mrbgSelect",
          label: "برگزیدن سرشاخه @@(سطح بالاتر)@@",
          firstOptLabel: "برگزیدن سرشاخه",
          optVarName: "hedLinParent__ST"
        },
        linkText: {
          type: "text",
          label: "متن لینک",
          other: {
            maxLength: 32,
            placeholder: "link text"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        linkUrl: {
          type: "mrbgSelect",
          label: "لینک",
          firstOptLabel: "برگزیدن صفحه",
          optVarName: "pagPath__ST"
        },
        id: {
          type: "mrbgSelect",
          label: "برگزیدن لینک هدر",
          firstOptLabel: "برگزیدن لینک هدر",
          optVarName: "hedLin__ST"
        }
      },
      forms: {
        hedLin: {
          title: "افزودن لینک هدر",
          operation: "ins",
          inputs: {
            parentID: {},
            linkText: {},
            linkUrl: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        hedLinUpd: {
          title: "به‌روزرسانی لینک هدر",
          operation: "upd",
          inputs: {
            id: {},
            linkText: {},
            linkUrl: {}
          },
          keys__FF: [
            "id"
          ],
          msg: true,
          btn: {
            label: "update",
            "class": "update"
          }
        },
        hedLinSrt: {
          title: "ترتیب لینک‌های هدر",
          operation: "srt",
          hierarchicalList: "hedLin__SL",
          hierarchicalListMaxDeep: 4,
          inputs: [],
          msg: true,
          btn: {
            label: "change",
            "class": "change"
          }
        },
        hedLinDlt: {
          title: "پاک کردن لینک از هدر",
          operation: "dlt",
          inputs: {
            id: {}
          },
          msg: true,
          btn: {
            label: "delete",
            "class": "delete"
          }
        }
      },
      tables: []
    },
    ourTem: {
      columns: {
        pagID: {
          type: "mrbgSelect",
          label: "برگزیدن صفحه",
          firstOptLabel: "برگزیدن صفحه",
          optVarName: "pag__ST"
        },
        position: {
          type: "text",
          label: "پوزیشن",
          other: {
            maxLength: 128,
            placeholder: "position"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        name: {
          type: "text",
          label: "نام",
          other: {
            maxLength: 128,
            placeholder: "name"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        img: {
          type: "mrbgImgFile",
          label: "برگزیدن عکس",
          other: {
            placeholder: "image",
            accept: "image/bmp,image/gif,image/jpeg,image/pjpeg,image/png,image/webp",
            "data-height": 480,
            "data-width": 640
          },
          fldAttr: {}
        },
        alt: {
          type: "text",
          label: "توضیحات عکس @@(for search engine optimization)@@",
          other: {
            maxLength: 1023,
            placeholder: "image's description"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        webSite: {
          type: "text",
          label: "وب‌سایت",
          other: {
            maxLength: 128,
            placeholder: "webSite"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        description: {
          type: "mrbgTE",
          label: "توضیحات",
          other: [],
          fldAttr: {
            className: [
              "frameMrbgTextEditor"
            ]
          }
        },
        id: {
          type: "mrbgSelect",
          label: "برگزیدن عضو تیم ما",
          firstOptLabel: "برگزیدن عضو تیم ما",
          optVarName: "ourTem__ST"
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ ایجاد",
          other: {
            placeholder: "from"
          }
        },
        updatedAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ به‌روزرسانی",
          other: {
            placeholder: "from"
          }
        }
      },
      forms: {
        ourTem: {
          title: "افزودن عضو تیم ما",
          operation: "ins",
          inputs: {
            pagID: {},
            position: {},
            name: {},
            img: {},
            alt: {},
            webSite: {},
            description: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        ourTemSrt: {
          title: "ترتیب اعضای تیم ما",
          operation: "srt",
          hierarchicalList: "ourTem__SL",
          inputs: {
            pagID: {}
          },
          msg: true,
          btn: {
            label: "change",
            "class": "change"
          }
        }
      },
      tables: {
        ourTem__TF: {
          tblID: "ourTem__TB",
          title: "لیست اعضای تیم ما",
          operation: "",
          filters: {
            id: {},
            pagID: {},
            position: {},
            name: {},
            alt: {},
            webSite: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: true,
          columns: {
            name: "",
            position: "سمت / موقعیت",
            img: "عکس",
            alt: "توضیحات عکس",
            description: "",
            webSite: "",
            createdBy: "ایجاد شده توسط",
            createdAt: "",
            updatedBy: "آخرین ویرایش توسط",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          msg: true
        }
      }
    },
    pag: {
      columns: {
        name: {
          type: "text",
          label: "نام",
          other: {
            maxLength: 128,
            placeholder: "name"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          },
          relativePath: "path"
        },
        path: {
          type: "text",
          label: "مسیر",
          other: {
            maxLength: 32,
            placeholder: "path"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        title: {
          type: "text",
          label: "عنوان",
          other: {
            maxLength: 255,
            placeholder: "title"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        keyWords: {
          type: "text",
          label: "واژگان کلیدی",
          other: {
            maxLength: 1023,
            placeholder: "key words"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        h1: {
          type: "text",
          label: "عنوان اصلی صفحه",
          other: {
            maxLength: 1023,
            placeholder: "H1"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        galleryTitle: {
          type: "text",
          label: "عنوان گالری تصاویر",
          other: {
            maxLength: 128,
            placeholder: "image's gallery title"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        ourTeamTitle: {
          type: "text",
          label: "عنوان تیم ما",
          other: {
            maxLength: 128,
            placeholder: "our team title"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        areaTitle: {
          type: "text",
          label: "عنوان برای نمایش ناحیه‌ها",
          other: {
            maxLength: 128,
            placeholder: "area title"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        contactUs: {
          type: "mrbgCheckBox",
          label: "فرم تماس با ما",
          other: {
            value: 1
          },
          fldAttr: {
            className: []
          }
        },
        workWithUs: {
          type: "mrbgCheckBox",
          label: "فرم همکاری با ما",
          other: {
            value: 1
          },
          fldAttr: {
            className: []
          }
        },
        description: {
          type: "mrbgTE",
          label: "توضیحات",
          other: {
            placeholder: "description",
            rows: 4
          },
          fldAttr: {
            className: [
              "mrbgVoice",
              "wideFieldset"
            ]
          }
        },
        id: {
          type: "mrbgSelect",
          label: "برگزیدن صفحه",
          firstOptLabel: "برگزیدن صفحه",
          optVarName: "pag__ST"
        },
        contactUsTitle: {
          type: "text",
          label: "تماس با ما",
          other: {
            maxLength: 128,
            placeholder: "contact us form"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ ایجاد",
          other: {
            placeholder: "from"
          }
        },
        updatedAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ به‌روزرسانی",
          other: {
            placeholder: "from"
          }
        }
      },
      forms: {
        pag: {
          title: "افزودن صفحه",
          operation: "ins",
          inputs: {
            name: {},
            path: {},
            title: {},
            keyWords: {},
            h1: {},
            galleryTitle: {},
            ourTeamTitle: {},
            areaTitle: {},
            contactUs: {},
            workWithUs: {},
            description: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        }
      },
      tables: {
        pag__TF: {
          tblID: "pag__TB",
          title: "لیست صفحات",
          operation: "",
          filters: {
            id: {},
            name: {},
            path: {},
            title: {},
            description: {},
            keyWords: {},
            h1: {},
            areaTitle: {},
            galleryTitle: {},
            ourTeamTitle: {},
            contactUsTitle: {},
            workWithUs: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: true,
          columns: {
            name: "",
            path: "",
            title: "",
            description: "",
            keyWords: "کلمات کلیدی",
            h1: "",
            areaTitle: "عنوان نمایش نواحی",
            galleryTitle: "",
            ourTeamTitle: "",
            contactUs: "",
            workWithUs: "",
            createdBy: "ایجاد شده توسط",
            createdAt: "",
            updatedBy: "آخرین ویرایش توسط",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          msg: true
        }
      }
    },
    sld: {
      columns: {
        pagID: {
          type: "mrbgSelect",
          label: "برگزیدن صفحه",
          firstOptLabel: "برگزیدن صفحه",
          optVarName: "pag__ST"
        },
        title: {
          type: "text",
          label: "عنوان",
          other: {
            maxLength: 63,
            placeholder: "title"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        subtitle: {
          type: "text",
          label: "زیرعنوان",
          other: {
            maxLength: 256,
            placeholder: "subtitle"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        btnText: {
          type: "text",
          label: "متن دکمه",
          other: {
            maxLength: 32,
            placeholder: "button text"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        link: {
          type: "mrbgSelect",
          label: "برگزیدن لینک",
          firstOptLabel: "برگزیدن لینک",
          optVarName: "pagPath__ST"
        },
        img: {
          type: "mrbgImgFile",
          label: "برگزیدن عکس",
          other: {
            placeholder: "image",
            accept: "image/bmp,image/gif,image/jpeg,image/pjpeg,image/png,image/webp",
            "data-height": 365,
            "data-width": 384
          },
          fldAttr: {}
        },
        alt: {
          type: "text",
          label: "توضیحات عکس @@(for search engine optimization)@@",
          other: {
            maxLength: 256,
            placeholder: "image's description"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        id: {
          type: "mrbgSelect",
          label: "برگزیدن اسلاید",
          firstOptLabel: "برگزیدن اسلاید",
          optVarName: "sld__ST"
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ ایجاد",
          other: {
            placeholder: "from"
          }
        },
        updatedAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ به‌روزرسانی",
          other: {
            placeholder: "from"
          }
        }
      },
      forms: {
        sld: {
          title: "افزودن اسلاید اسلایدر",
          operation: "ins",
          inputs: {
            pagID: {},
            title: {},
            subtitle: {},
            btnText: {},
            link: {},
            img: {},
            alt: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        sldSrt: {
          title: "ترتیب اسلایدهای اسلایدر",
          operation: "srt",
          hierarchicalList: "sld__SL",
          keys__FF: [
            "pagID"
          ],
          op__FF: "gSL",
          msg: true,
          btn: {
            label: "change",
            "class": "change"
          }
        }
      },
      tables: {
        sld__TF: {
          tblID: "sld__TB",
          title: "لیست اسلایدها",
          operation: "",
          filters: {
            id: {},
            pagID: {},
            title: {},
            btnText: {},
            link: {},
            alt: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: true,
          columns: {
            name: "نام",
            title: "",
            subtitle: "",
            btnText: "",
            link: "لینک",
            img: "عکس",
            alt: "توضیحات عکس",
            createdBy: "ایجاد شده توسط",
            createdAt: "",
            updatedBy: "آخرین ویرایش توسط",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          msg: true
        }
      }
    }
  },
  EP: {
    apoSes: {
      columns: {
        id: {
          type: "mrbgSelect",
          label: "برگزیدن نوبت",
          firstOptLabel: "برگزیدن نوبت",
          optVarName: "apoSes__ST",
        },
        cliID: {
          type: "mrbgSelect",
          label: "مشتری",
          firstOptLabel: "برگزیدن مشتری",
          optVarName: "cli__ST"
        },
        areID: {
          type: "mrbgSelect",
          label: "برگزیدن ناحیه",
          firstOptLabel: "برگزیدن ناحیه",
          optVarName: "are__ST",
          mode: "multi"
        },
        devID: {
          type: "mrbgRadioInput",
          label: "دستگاه",
          values: "dev__ST"
        },
        bookingMethod: {
          type: "mrbgSelect",
          label: "روش رزرو",
          firstOptLabel: "برگزیدن روش رزرو",
          optVarName: "bokMet__ST"
        },
        totalAmount: {
          type: "mrbgNumberInput",
          label: "مبلغ صورتحساب",
          other: {
            placeholder: "Billed Amount"
          }
        },
        discountAmount: {
          type: "mrbgNumberInput",
          label: "مبلغ تخفیف",
          other: {
            placeholder: "Discount Amount"
          }
        },
        finalAmount: {
          type: "mrbgNumberInput",
          label: "مبلغ نهایی",
          other: {
            placeholder: "Final Amount"
          }
        },
        totalAmountPaid: {
          type: "mrbgNumberInput",
          label: "مجموع پرداخت شده",
          other: {
            placeholder: "Total Amount Paid"
          }
        },
        deduction: {
          type: "mrbgNumberInput",
          label: "کسورات",
          other: {
            placeholder: "Total Amount Paid"
          }
        },
        createdBy: {
          type: "mrbgSelect",
          label: "ایجاد شده توسط",
          firstOptLabel: "ایجاد شده توسط",
          optVarName: "empUser__ST"
        },
        updatedBy: {
          type: "mrbgSelect",
          label: "آخرین ویرایش توسط",
          firstOptLabel: "آخرین ویرایش توسط",
          optVarName: "empUser__ST"
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ ایجاد",
          other: {
            placeholder: "from"
          }
        },
        updatedAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ به‌روزرسانی",
          other: {
            placeholder: "from"
          }
        },
        beginDateTime: {
          type: "mrbgPersianDateTime",
          label: "تاریخ و زمان",
          other: {
            placeholder: "Service Datetime"
          },
          storeInRedux: true
        },
        customDuration: {
          type: "mrbgNumberInput",
          label: "مدت زمان نوبت @@(در صورت نیاز بر حسب دقیقه)@@",
          other: {
            max: 300,
            min: 0,
            placeholder: "duration"
          }
        },
        force: {
          type: "mrbgCheckBox",
          label: "عجله داره",
          other: {
            value: 1
          }
        },
        secretaryNote: {
          type: "textarea",
          label: "یادداشت‌",
          other: {
            placeholder: "Notes",
            rows: 4,
            maxLength: 1024
          },
          fldAttr: {
            className: [
              "mrbgVoice",
              "wideFieldset"
            ]
          }
        },
        amount: {
          type: "mrbgNumberInput",
          label: "مبلغ",
          other: {
            max: 2147483648,
            min: 0,
            placeholder: "amount"
          }
        },
        paidType: {
          type: "mrbgSelect",
          label: "نوع پرداخت",
          firstOptLabel: "برگزیدن نوع",
          optVarName: "paidType__ST",
          other: {}
        },
        funID: {
          type: "mrbgSelect",
          label: "برگزیدن حساب",
          firstOptLabel: "برگزیدن حساب",
          optVarName: "fun__ST",
          other: {}
        },
        apoSesID: {
          type: "mrbgSelect",
          label: "برگزیدن نوبت",
          firstOptLabel: "برگزیدن نوبت",
          optVarName: "activeAbleSession__ST"
        },
        shutCount: {
          type: "mrbgNumberInput",
          label: "تعداد شات",
          other: {
            maxLength: 128,
            placeholder: "shut Count"
          }
        },
        operatorNote: {
          type: "textarea",
          label: "یادداشت‌",
          other: {
            placeholder: "Notes",
            rows: 4,
            maxLength: 1024
          },
          fldAttr: {
            className: [
              "mrbgVoice",
              "wideFieldset"
            ]
          }
        },
        entID: {
          type: "mrbgSelect",
          label: "برگزیدن ماده مصرفی",
          firstOptLabel: "برگزیدن ماده مصرفی",
          optVarName: "ent__ST"
        },
        quantity: {
          type: "mrbgNumberInput",
          label: "تعداد",
          other: {
            maxLength: 32,
            placeholder: "quantity"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        }
      },
      forms: {
        specialDate: {
          title: "تایم لاین تاریخ انتخابی",
          operation: "checkFreeTime",
          inputs: {
            beginDateTime: {
              type: "mrbgPersianDate",
              label: "تاریخ",
              other: {
                placeholder: "Service Datetime"
              },
              storeInRedux: true
            }
          },
          timeLine: "specialDate__TL"
        },
        apoResUpd: {
          title: "ویرایش نوبت‌های رزروی",
          operation: "upd",
          inputs: {
            areID: {
              optVarName: "areFull__ST",
              popupObj: {
                id: "areaSelectionFrame",
                icon: "fa-solid fa-user-magnifying-glass"
              }
            },
            beginDateTime: {},
            customDuration: {},
            devID: {},
            force: {},
            secretaryNote: {}
          },
          parts: {
            bilPay: {
              title: "پیش پرداخت",
              inputs: {
                amount: {},
                paidType: {},
                funID: {}
              }
            }
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        apoSesAct: {
          title: "اکتیو نمودن سرویس",
          operation: "activate",
          inputs: {
            apoSesID: {},
            areID: {}
          },
          tableInputs: {
            apoSesFin__TB: {
              influenceName: "areID",
              influenceOptions: "are__ST",
              columns: {
                areID: {
                  label: "نام ناحیه",
                  type: "string"
                },
                operator: {
                  label: "کارمند اپراتور",
                  type: "text",
                  other: {
                    list: "operator__DL"
                  },
                  storeInRedux: true
                }
              }
            }
          },
          keys__FF: [
            "apoSesID"
          ],
          op__FF: "GFA",
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        apoSesFin: {
          title: "گزارش پایان سرویس",
          operation: "finish",
          inputs: {
            shutCount: {},
            areID: {},
            operatorNote: {}
          },
          parts: {
            entPrt: {
              subTitle: "مواد مصرفی",
              repeat: 1,
              inputs: {
                entID: {},
                quantity: {}
              }
            }
          },
          tableInputs: {
            apoSesFin__TB: {
              influenceName: "areID",
              influenceOptions: "are__ST",
              columns: {
                areID: {
                  label: "نام ناحیه",
                  type: "string"
                },
                energy: {
                  type: "text",
                  label: "انرژی",
                  other: {
                    maxLength: 512,
                    placeholder: "energy",
                    inputMode: "tel"
                  },
                  fldAttr: {
                    className: [
                      "mrbgVoice"
                    ]
                  }
                },
                canceled: {
                  label: "کنسل از طرف مشتری",
                  type: "mrbgCheckBox",
                  other: {
                    value: 1
                  }
                },
                postponed: {
                  label: "موکول به آینده",
                  type: "mrbgCheckBox",
                  other: {
                    value: 1
                  }
                }
              }
            }
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        apoSesFixToCancel: {
          title: "کنسل کردن نوبت های فیکس شده",
          operation: "fixCancel",
          inputs: {
            id: {
              optVarName: "fixApoSes__ST"
            },
            amount: {
              label: "چه مبلغی از این صورت حساب باید به ولت مشتری افزوده شود؟",
            }
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        notificationUpd_DT: {
          operation: "updDate",
          inputs: {
            devID: {
              type: "mrbgRadioInput",
              label: "دستگاه",
              values: "dev__ST"
            },
            beginDateTime: {
              type: "mrbgPersianDateTime",
              label: "تاریخ و زمان",
              alwaysOpen: true,
              storeInRedux: true
            },
          },
          msg: true
        },
        timeLineUpd_DT: {
          operation: "updDate",
          inputs: {
            devID: {
              type: "mrbgRadioInput",
              label: "دستگاه",
              values: "dev__ST"
            },
            beginDateTime: {
              type: "mrbgPersianDateTime",
              label: "تاریخ و زمان",
              alwaysOpen: true,
              storeInRedux: true
            },
          },
          msg: true
        }
      },
      tables: {
        todaySession__TF: {
          tblID: "todaySession__TB",
          title: "لیست نوبت‌های امروز",
          operation: "",
          filters: {
            id: {},
            cliID: {},
            areID: {},
            devID: {},
            bookingMethod: {},
            totalAmount: {},
            discountAmount: {},
            finalAmount: {},
            totalAmountPaid: {},
            deduction: {},
            createdBy: {},
            updatedBy: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: false,
          view: true,
          columns: {
            code: "کد نوبت",
            fullName: "نام مشتری",
            areName: "نواحی",
            serviceTime: "زمان نوبت",
            bookingStatus: "وضعیت",
            devName: "دستگاه",
            operator: "اپراتور",
            force: "عجله دارم",
            shutCount: "تعداد شات",
            bookingMethod: "",
            totalAmount: "",
            entitiesAmount: "هزینه مواد مصرفی",
            discountAmount: "",
            finalAmount: "",
            totalAmountPaid: "",
            outstandingBalance: "مبلغ باقیمانده",
            deduction: "",
            یادداشت‌ها: {
              secretaryNote: "منشی",
              operatorNote: "اپراتور"
            },
            createdBy: "",
            createdAt: "",
            updatedBy: "",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          component: {
            serviceTime: "bdi",
            bookingStatus: "bookingStatus",
            outstandingBalance: "price",
            entitiesAmount: "price"
          },
          msg: true
        },
        tomorrowSession__TF: {
          tblID: "tomorrowSession__TB",
          title: "لیست نوبت‌های فردا",
          operation: "",
          filters: {
            id: {},
            cliID: {},
            areID: {},
            devID: {},
            bookingMethod: {},
            totalAmount: {},
            discountAmount: {},
            finalAmount: {},
            totalAmountPaid: {},
            deduction: {},
            createdBy: {},
            updatedBy: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: false,
          view: true,
          columns: {
            code: "کد نوبت",
            fullName: "نام مشتری",
            areName: "نواحی",
            serviceTime: "زمان نوبت",
            bookingStatus: "وضعیت",
            devName: "دستگاه",
            force: "عجله دارم",
            shutCount: "تعداد شات",
            bookingMethod: "",
            totalAmount: "",
            discountAmount: "",
            finalAmount: "",
            totalAmountPaid: "",
            outstandingBalance: "مبلغ باقیمانده",
            deduction: "",
            یادداشت‌ها: {
              secretaryNote: "منشی",
              operatorNote: "اپراتور"
            },
            createdBy: "",
            createdAt: "",
            updatedBy: "",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          component: {
            serviceTime: "bdi",
            bookingStatus: "bookingStatus",
            outstandingBalance: "price",
            entitiesAmount: "price"
          },
          msg: true
        },
        afterTomorrowSession__TF: {
          tblID: "afterTomorrowSession__TB",
          title: "لیست نوبت‌های پس فردا",
          operation: "",
          filters: {
            id: {},
            cliID: {},
            areID: {},
            devID: {},
            bookingMethod: {},
            totalAmount: {},
            discountAmount: {},
            finalAmount: {},
            totalAmountPaid: {},
            deduction: {},
            createdBy: {},
            updatedBy: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: false,
          view: true,
          columns: {
            code: "کد نوبت",
            fullName: "نام مشتری",
            areName: "نواحی",
            serviceTime: "زمان نوبت",
            bookingStatus: "وضعیت",
            devName: "دستگاه",
            force: "عجله دارم",
            shutCount: "تعداد شات",
            bookingMethod: "",
            totalAmount: "",
            discountAmount: "",
            finalAmount: "",
            totalAmountPaid: "",
            outstandingBalance: "مبلغ باقیمانده",
            deduction: "",
            یادداشت‌ها: {
              secretaryNote: "منشی",
              operatorNote: "اپراتور"
            },
            createdBy: "",
            createdAt: "",
            updatedBy: "",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          component: {
            serviceTime: "bdi",
            bookingStatus: "bookingStatus",
            outstandingBalance: "price",
            entitiesAmount: "price"
          },
          msg: true
        },
        forceSession__TF: {
          tblID: "forceSession__TB",
          title: "لیست عجله دارها",
          operation: "",
          filters: {
            id: {},
            cliID: {},
            areID: {},
            devID: {},
            bookingMethod: {},
            totalAmount: {},
            discountAmount: {},
            finalAmount: {},
            totalAmountPaid: {},
            deduction: {},
            createdBy: {},
            updatedBy: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: false,
          trash: false,
          view: true,
          columns: {
            code: "کد نوبت",
            fullName: "نام مشتری",
            areName: "نواحی",
            beginDateTime: "تاریخ نوبت",
            serviceTime: "زمان نوبت",
            bookingStatus: "وضعیت",
            devName: "دستگاه",
            force: "عجله دارم",
            shutCount: "تعداد شات",
            bookingMethod: "",
            totalAmount: "",
            discountAmount: "",
            finalAmount: "",
            totalAmountPaid: "",
            outstandingBalance: "مبلغ باقیمانده",
            deduction: "",
            یادداشت‌ها: {
              secretaryNote: "منشی",
              operatorNote: "اپراتور"
            },
            createdBy: "",
            createdAt: "",
            updatedBy: "",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          component: {
            beginDateTime: "date",
            serviceTime: "bdi",
            bookingStatus: "bookingStatus",
            outstandingBalance: "price",
            entitiesAmount: "price"
          },
          msg: true
        },
        missedClients__TF: {
          tblID: "missedClients__TB",
          title: "کیس‌های بدون نوبت @@(کیس‌هایی که 1 الی 4 ماه از آخرین نوبت آنها گذشته است.)@@",
          operation: "",
          filters: {
            id: {},
            cliID: {},
            areID: {},
            devID: {},
            bookingMethod: {},
            beginDateTime: {},
            totalAmount: {},
            discountAmount: {},
            finalAmount: {},
            totalAmountPaid: {},
            deduction: {},
            createdBy: {},
            updatedBy: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: false,
          trash: false,
          view: true,
          columns: {
            code: "کد نوبت",
            fullName: "نام مشتری",
            phone: "تلفن",
            SetMissedFollow: "ثبت پیگیری",
            missedFollowDate: "تاریخ آ.پ.",
            missedFollowNote: "یادداشت آ.پ.",
            areName: "نواحی",
            beginDateTime: "تاریخ نوبت",
            serviceTime: "زمان نوبت",
            bookingStatus: "وضعیت",
            devName: "دستگاه",
            operator: "اپراتور",
            shutCount: "تعداد شات",
            bookingMethod: "",
            totalAmount: "",
            entitiesAmount: "هزینه مواد مصرفی",
            discountAmount: "",
            finalAmount: "",
            totalAmountPaid: "",
            outstandingBalance: "مبلغ باقیمانده",
            deduction: "",
            یادداشت‌ها: {
              secretaryNote: "منشی",
              operatorNote: "اپراتور"
            },
            createdBy: "",
            createdAt: "",
            updatedBy: "",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          component: {
            beginDateTime: "date",
            serviceTime: "bdi",
            bookingStatus: "bookingStatus",
            outstandingBalance: "price",
            entitiesAmount: "price",
            SetMissedFollow: "SetMissedFollow",
            missedFollowDate: "dateTime",
          },
          msg: true
        },
        apoRes__TF: {
          tblID: "apoRes__TB",
          title: "لیست نوبت‌های رزروی",
          operation: "",
          filters: {
            id: {},
            cliID: {},
            areID: {},
            devID: {},
            beginDateTime: {},
            bookingMethod: {},
            totalAmount: {},
            discountAmount: {},
            finalAmount: {},
            totalAmountPaid: {},
            deduction: {},
            createdBy: {},
            updatedBy: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: false,
          view: true,
          columns: {
            code: "کد نوبت",
            fullName: "نام مشتری",
            areName: "نواحی",
            beginDateTime: "تاریخ نوبت",
            serviceTime: "زمان نوبت",
            bookingStatus: "وضعیت",
            devName: "دستگاه",
            shutCount: "تعداد شات",
            bookingMethod: "",
            totalAmount: "",
            discountAmount: "",
            finalAmount: "",
            totalAmountPaid: "",
            outstandingBalance: "مبلغ باقیمانده",
            deduction: "",
            یادداشت‌ها: {
              secretaryNote: "منشی",
              operatorNote: "اپراتور"
            },
            createdBy: "",
            createdAt: "",
            updatedBy: "",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          component: {
            beginDateTime: "date",
            serviceTime: "bdi",
            bookingStatus: "bookingStatus",
            outstandingBalance: "price",
            entitiesAmount: "price"
          },
          msg: true
        },
        allSession__TF: {
          tblID: "allSession__TB",
          title: "لیست تمام نوبت ها",
          operation: "",
          filters: {
            id: {},
            cliID: {},
            areID: {},
            devID: {},
            beginDateTime: {},
            bookingMethod: {},
            totalAmount: {},
            discountAmount: {},
            finalAmount: {},
            totalAmountPaid: {},
            deduction: {},
            createdBy: {},
            updatedBy: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: false,
          view: true,
          columns: {
            code: "کد نوبت",
            fullName: "نام مشتری",
            areName: "نواحی",
            beginDateTime: "تاریخ نوبت",
            serviceTime: "زمان نوبت",
            bookingStatus: "وضعیت",
            devName: "دستگاه",
            operator: "اپراتور",
            shutCount: "",
            bookingMethod: "",
            totalAmount: "",
            entitiesAmount: "هزینه مواد مصرفی",
            discountAmount: "",
            finalAmount: "",
            totalAmountPaid: "",
            outstandingBalance: "مبلغ باقیمانده",
            deduction: "",
            یادداشت‌ها: {
              secretaryNote: "منشی",
              operatorNote: "اپراتور"
            },
            createdBy: "",
            createdAt: "",
            updatedBy: "",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          component: {
            beginDateTime: "date",
            serviceTime: "bdi",
            bookingStatus: "bookingStatus",
            outstandingBalance: "price",
            entitiesAmount: "price"
          },
          msg: true
        }
      }
    },
    "3dayChart__TL": {
      id: "3dayChart__TL",
      title: "نمودار نوبت‌های سه روزه"
    },
    apo: {
      columns: {
        cliID: {
          type: "mrbgSelect",
          label: "برگزیدن مشتری",
          firstOptLabel: "برگزیدن مشتری",
          optVarName: "cli__ST",
          popupObj: {
            id: "cliFrame",
            icon: "fa-solid fa-plus-square"
          }
        },
        areID: {
          type: "mrbgSelect",
          label: "برگزیدن ناحیه",
          firstOptLabel: "برگزیدن ناحیه",
          optVarName: "areFull__ST",
          mode: "multi",
          popupObj: {
            id: "areaSelectionFrame",
            icon: "fa-solid fa-user-magnifying-glass"
          }
        },
        customDuration: {
          type: "mrbgNumberInput",
          label: "مدت زمان نوبت @@(در صورت نیاز بر حسب دقیقه)@@",
          other: {
            max: 300,
            min: 0,
            placeholder: "duration"
          }
        },
        bookingMethod: {
          type: "mrbgSelect",
          label: "روش رزرو",
          firstOptLabel: "برگزیدن روش رزرو",
          optVarName: "bokMet__ST"
        },
        force: {
          type: "mrbgCheckBox",
          label: "عجله داره",
          other: {
            value: 1
          }
        },
        secretaryNote: {
          type: "textarea",
          label: "یادداشت‌",
          other: {
            placeholder: "Notes",
            rows: 2,
            maxLength: 1024
          },
          fldAttr: {
            className: [
              "mrbgVoice",
              "wideFieldset"
            ]
          }
        },
        beginDateTime: {
          type: "mrbgPersianDateTime",
          label: "تاریخ و زمان",
          other: {
            placeholder: "Service Datetime"
          },
          storeInRedux: true
        },
        devID: {
          type: "mrbgRadioInput",
          label: "دستگاه",
          values: "dev__ST"
        },
        amount: {
          type: "mrbgNumberInput",
          label: "مبلغ",
          other: {
            max: 2147483648,
            min: 0,
            placeholder: "amount"
          },
          storeInRedux: true
        },
        paidType: {
          type: "mrbgSelect",
          label: "نوع پرداخت",
          firstOptLabel: "برگزیدن نوع",
          optVarName: "paidType__ST",
          other: {}
        },
        funID: {
          type: "mrbgSelect",
          label: "برگزیدن حساب",
          firstOptLabel: "برگزیدن حساب",
          optVarName: "fun__ST"
        },
      },
      forms: {
        apoRes: {
          title: "رزرو نوبت",
          popupObj: {
            id: "apoResGuide",
            icon: "fa-solid fa-seal-question"
          },
          operation: "resIns",
          inputs: {
            cliID: {},
            areID: {},
            customDuration: {},
            bookingMethod: {},
            force: {},
            secretaryNote: {}
          },
          parts: {
            datePrt: {
              title: "برگزیدن تاریخ‌ها و زمان‌ها",
              subTitle: "جلسه",
              repeat: 1,
              inputs: {
                beginDateTime: {},
                devID: {}
              }
            },
            bilPay: {
              title: "پیش پرداخت",
              inputs: {
                amount: {},
                paidType: {},
                funID: {}
              }
            }
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        apoFilterPC: {
          title: "فیلتر پای چارت",
          operation: "chtFlt",
          inputs: {
            beginDateTime__0: {},
            beginDateTime__1: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        }
      },
      tables: []
    },
    FUA: {
      columns: {
        apoSesID: {
          type: "mrbgSelect",
          label: "برگزیدن نوبت",
          firstOptLabel: "برگزیدن نوبت",
          optVarName: "bookedSession__ST"
        },
        outcomeStatus: {
          type: "mrbgSelect",
          label: "نتیجه پیگیری",
          firstOptLabel: "برگزیدن وضعیت پیگیری",
          optVarName: "outcome__ST",
          other: {}
        },
        remindDateTime: {
          type: "mrbgPersianDateTime",
          label: "زمان پیگیری بعدی",
          other: {
            placeholder: "Next follow-up time"
          }
        },
        amount: {
          type: "mrbgNumberInput",
          label: "مبلغ بیعانه@@(تومان)@@",
          other: {
            max: 2147483648,
            min: 0,
            placeholder: "amount"
          }
        },
        notes: {
          type: "textarea",
          label: "یادداشت‌",
          other: {
            placeholder: "Notes",
            rows: 4
          },
          fldAttr: {
            className: [
              "mrbgVoice",
              "wideFieldset"
            ]
          }
        },
        treatmentID: {
          type: "mrbgNumberInput",
          label: "کد نوبت",
          other: {
            placeholder: "Treatment ID"
          }
        },
        note: {
          type: "text",
          label: "یادداشت‌",
          other: {
            placeholder: "Notes"
          }
        },
        recordedBy: {
          type: "mrbgSelect",
          label: "ثبت کننده پیگیری",
          firstOptLabel: "برگزیدن ثبت کننده",
          optVarName: "empUser__ST"
        },
        scheduledRetryNotes: {
          type: "text",
          label: "یادداشت‌های تلاش مجدد",
          other: {
            placeholder: "Retry Notes"
          }
        },
        scheduledRetryDatetime: {
          type: "mrbgPersianDateTime",
          label: "تاریخ و زمان تلاش مجدد",
          other: {
            placeholder: "from"
          }
        },
        createdBy: {
          type: "mrbgSelect",
          label: "ایجاد شده توسط",
          firstOptLabel: "ایجاد شده توسط",
          optVarName: "empUser__ST"
        },
        updatedBy: {
          type: "mrbgSelect",
          label: "آخرین ویرایش توسط",
          firstOptLabel: "آخرین ویرایش توسط",
          optVarName: "empUser__ST"
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ ایجاد",
          other: {
            placeholder: "from"
          }
        },
        updatedAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ به‌روزرسانی",
          other: {
            placeholder: "from"
          }
        }
      },
      forms: {
        FUA: {
          title: "افزودن تلاش پیگیری جدید",
          operation: "ins",
          inputs: {
            apoSesID: {},
            outcomeStatus: {},
            remindDateTime: {},
            amount: {},
            notes: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        }
      },
      tables: {
        FUA__TF: {
          tblID: "FUA__TB",
          title: "لیست تلاش‌های پیگیری",
          operation: "",
          filters: {
            treatmentID: {},
            outcomeStatus: {},
            note: {},
            recordedBy: {},
            scheduledRetryNotes: {},
            scheduledRetryDatetime: {},
            createdBy: {},
            updatedBy: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: true,
          columns: {
            fullName: "نام مشتری",
            code: "کد نوبت",
            outcomeStatus: "",
            remindDateTime: "",
            notes: "",
            createdBy: "",
            createdAt: "",
            updatedBy: "",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          msg: true
        }
      }
    },
    finance__FC: {
      "0": {
        id: "dailyFin1__FC",
        title: "نمودارهای مالی روزانه دستگاه اول"
      },
      "1": {
        id: "dailyFin2__FC",
        title: "نمودارهای مالی روزانه دستگاه دوم"
      },
      "2": {
        id: "monthlyFin1__FC",
        title: "نمودارهای مالی ماهیانه دستگاه اول"
      },
      "3": {
        id: "monthlyFin2__FC",
        title: "نمودارهای مالی ماهیانه دستگاه دوم"
      },
      "4": {
        id: "yearlyFin__FC",
        title: "نمودارهای مالی سالیانه"
      }
    },
    appointment__PC: {
      "0": {
        id: "gender__PC",
        title: "نمودار جنسیت مشتریان"
      },
      "1": {
        id: "area__PC",
        title: "نمودار نواحی"
      },
      "2": {
        id: "funds__PC",
        title: "نمودار منابع مالی"
      },
      "3": {
        id: "operator__PC",
        title: "نمودار کارکرد اپراتور ها"
      }
    },
    clientsHistory__SS: {
      id: "clientsHistory__SS",
      title: "تاریخچه مشتری"
    },
    fun: {
      columns: {
        type: {
          type: "mrbgSelect",
          label: "برگزیدن نوع",
          firstOptLabel: "برگزیدن نوع",
          optVarName: "funType__ST"
        },
        name: {
          type: "text",
          label: "نام حساب",
          other: {
            maxLength: 128,
            placeholder: "name"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        inventory: {
          type: "mrbgNumberInput",
          label: "موجودی@@(تومان)@@",
          other: {
            max: 4294967296,
            min: 0,
            placeholder: "inventory"
          }
        },
        funID: {
          type: "mrbgSelect",
          label: "حساب بانکی",
          firstOptLabel: "برگزیدن حساب بانکی",
          optVarName: "fun__ST"
        },
        createdBy: {
          type: "mrbgSelect",
          label: "ایجاد شده توسط",
          firstOptLabel: "ایجاد شده توسط",
          optVarName: "empUser__ST"
        },
        updatedBy: {
          type: "mrbgSelect",
          label: "آخرین ویرایش توسط",
          firstOptLabel: "آخرین ویرایش توسط",
          optVarName: "empUser__ST"
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ ایجاد",
          other: {
            placeholder: "from"
          }
        },
        updatedAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ به‌روزرسانی",
          other: {
            placeholder: "from"
          }
        }
      },
      forms: {
        fun: {
          title: "تعریف حساب بانکی / صندوق نقدی",
          operation: "ins",
          inputs: {
            type: {},
            name: {},
            inventory: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        }
      },
      tables: {
        fun__TF: {
          tblID: "fun__TB",
          title: "لیست منابع مالی",
          operation: "",
          filters: {
            funID: {},
            type: {},
            inventory: {},
            createdBy: {},
            updatedBy: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: true,
          columns: {
            name: "",
            type: "نوع صندوق",
            inventory: "موجودی",
            createdBy: "درج کننده",
            createdAt: "زمان درج",
            updatedBy: "آخرین ویرایشگر",
            updatedAt: "زمان آخرین ویرایش",
            ERP_updatedAt: "آخرین ویرایش خودکار"
          },
          component: {
            balance: "balance"
          },
          msg: true
        }
      }
    },
    bil: {
      columns: {
        id: {
          type: "mrbgSelect",
          label: "برگزیدن صورت حساب",
          firstOptLabel: "برگزیدن صورت حساب",
          optVarName: "openBil__ST"
        },
        bilGrpID: {
          type: "mrbgSelect",
          label: "برگزیدن گروه صورت حساب",
          firstOptLabel: "برگزیدن گروه صورت حساب",
          optVarName: "bilGrp_Expenses__ST"
        },
        title: {
          type: "text",
          label: "عنوان@@(یک توضیح مختصر، مثلا علت انتقال)@@",
          other: {
            maxLength: 128,
            placeholder: "title"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        totalAmount: {
          type: "mrbgNumberInput",
          label: "مبلغ",
          other: {
            max: 2147483648,
            min: 0,
            placeholder: "amount"
          }
        },
        amount: {
          type: "mrbgNumberInput",
          label: "مبلغ",
          other: {
            max: 2147483648,
            min: 0,
            placeholder: "amount"
          }
        },
        paidType: {
          type: "mrbgSelect",
          label: "نوع پرداخت",
          firstOptLabel: "برگزیدن نوع",
          optVarName: "paidType__ST",
          other: {}
        },
        funID: {
          type: "mrbgSelect",
          label: "برگزیدن حساب",
          firstOptLabel: "برگزیدن حساب",
          optVarName: "fun__ST"
        },
        paidDateTime: {
          type: "mrbgPersianDateTime",
          label: "تاریخ و زمان پرداخت"
        },
        discount: {
          type: "mrbgNumberInput",
          label: "مبلغ تخفیف",
          other: {
            placeholder: "Discount Amount"
          }
        },
        deduction: {
          type: "mrbgNumberInput",
          label: "کسورات",
          other: {
            placeholder: "Final Amount"
          }
        },
        manualAdjustment: {
          type: "mrbgNumberInput",
          label: "تعدیل قیمت (@@این مبلغ از مبلغ نهایی کم می شود.@@)",
          other: {
            max: 2147483648,
            min: 0,
            placeholder: "amount difference"
          }
        },
        finalAmount: {
          type: "mrbgNumberInput",
          label: "مبلغ نهایی",
          other: {
            placeholder: "final Amount"
          }
        },
        revoke: {
          type: "hidden",
          other: {
            value: "0",
            "data-role": "mrbgTblIndicator"
          }
        },
        createdBy: {
          type: "mrbgSelect",
          label: "ایجاد شده توسط",
          firstOptLabel: "ایجاد شده توسط",
          optVarName: "empUser__ST"
        },
        updatedBy: {
          type: "mrbgSelect",
          label: "آخرین ویرایش توسط",
          firstOptLabel: "آخرین ویرایش توسط",
          optVarName: "empUser__ST"
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ ایجاد",
          other: {
            placeholder: "from"
          }
        },
        updatedAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ به‌روزرسانی",
          other: {
            placeholder: "from"
          }
        }
      },
      forms: {
        revenues: {
          title: "ثبت سایر درآمدها @@(به جز نوبت و فروش مواد مصرفی)@@",
          operation: "insRev",
          inputs: {
            bilGrpID: {},
            title: {},
            totalAmount: {}
          },
          parts: {
            bilPay: {
              title: "پیش پرداخت",
              inputs: {
                amount: {},
                paidType: {},
                funID: {},
                paidDateTime: {}
              }
            }
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        expenses: {
          title: "ثبت هزینه‌ها",
          operation: "insExp",
          inputs: {
            bilGrpID: {},
            title: {},
            totalAmount: {}
          },
          parts: {
            bilPay: {
              title: "پیش پرداخت",
              inputs: {
                amount: {},
                paidType: {},
                funID: {},
                paidDateTime: {}
              }
            }
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        bilPay: {
          title: "پرداخت صورت حساب",
          operation: "pay",
          inputs: {
            id: {},
            manualAdjustment: {},
            amount: {
              type: "bilPayInfo"
            }
          },
          parts: {
            payInfo: {
              title: "اطلاعات پرداخت",
              subTitle: "پرداخت",
              repeat: 1,
              inputs: {
                amount: {},
                paidType: {},
                funID: {},
                paidDateTime: {}
              }
            }
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        bilRvk: {
          title: "ابطال صورت حساب",
          operation: "rvc",
          inputs: {
            id: {
              optVarName: "rvcBil__ST"
            }
          },
          msg: true,
          btn: {
            label: "revoke",
            "class": "confirm"
          }
        },
      },
      tables: {
        openBil__TF: {
          tblID: "openBil__TB",
          title: "لیست صورت حساب‌های باز @@(پرداخت نشده)@@",
          operation: "",
          filters: {
            id: {},
            bilGrpID: {},
            totalAmount: {},
            discount: {},
            deduction: {},
            manualAdjustment: {},
            finalAmount: {},
            createdBy: {},
            updatedBy: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: false,
          trash: false,
          columns: {
            code: "کد صورت حساب",
            bilGrpName: "گروه صورت حساب",
            title: "عنوان",
            apoSesCode: "جلسه",
            مبلغ: {
              totalAmount: "کل",
              discount: "تخفیف",
              deduction: "کسورات",
              finalAmount: "نهایی",
              paidAmount: "پرداخت شده"
            },
            createdBy: "درح کننده",
            createdAt: "زمان درح",
            updatedBy: "آخرین ویرایشگر",
            updatedAt: "زمان آخرین ویرایش",
            ERP_updatedAt: "آخرین ویرایش خودگار"
          },
          component: {
            totalAmount: "price",
            discount: "price",
            deduction: "price",
            finalAmount: "price",
            paidAmount: "price",
            bilPayPaidDateTime: "dateTime",
            ERP_updatedAt: "dateTime"
          },
          msg: true
        },
        closedBil__TF: {
          tblID: "closedBil__TB",
          title: "لیست صورت حساب‌های بسته @@(پرداخت شده)@@",
          operation: "",
          filters: {
            id: {},
            bilGrpID: {},
            totalAmount: {},
            discount: {},
            deduction: {},
            manualAdjustment: {},
            finalAmount: {},
            createdBy: {},
            updatedBy: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: false,
          trash: false,
          columns: {
            code: "کد صورت حساب",
            bilGrpName: "گروه صورت حساب",
            title: "عنوان",
            apoSesCode: "جلسه",
            مبلغ: {
              totalAmount: "کل",
              discount: "تخفیف",
              deduction: "کسورات",
              finalAmount: "نهایی",
              paidAmount: "پرداخت شده"
            },
            پرداختی: {
              funName: "نام حساب",
              bilPayAmount: "مبلغ",
              bilPayType: "نوع",
              bilPayPaidDateTime: "زمان"
            },
            createdBy: "درح کننده",
            createdAt: "زمان درح",
            updatedBy: "آخرین ویرایشگر",
            updatedAt: "زمان آخرین ویرایش",
            ERP_updatedAt: "آخرین ویرایش خودگار"
          },
          component: {
            totalAmount: "price",
            discount: "price",
            deduction: "price",
            finalAmount: "price",
            paidAmount: "price",
            bilPayAmount: "price",
            bilPayPaidDateTime: "dateTime",
            ERP_updatedAt: "dateTime"
          },
          msg: true
        },
        cardConfirm__TF: {
          tblID: "cardConfirm__TB",
          title: "لیست کارت به کارت های تایید نشده",
          operation: "",
          filters: {
            revoke: {}
          },
          rowsCol: true,
          pencil: false,
          trash: false,
          columns: {
            code: "کد صورت حساب",
            bilGrpName: "گروه صورت حساب",
            title: "عنوان",
            apoSesCode: "جلسه",
            پرداختی: {
              funName: "نام حساب",
              bilPayAmount: "مبلغ",
              bilPayType: "نوع",
              bilPayPaidDateTime: "زمان"
            },
            مبلغ: {
              totalAmount: "کل",
              discount: "تخفیف",
              deduction: "کسورات",
              finalAmount: "نهایی",
              paidAmount: "پرداخت شده"
            },
            createdBy: "درح کننده",
            createdAt: "زمان درح",
            updatedBy: "آخرین ویرایشگر",
            updatedAt: "زمان آخرین ویرایش",
            removedBy: "زمان آخرین ویرایش",
            removedAt: "حذف کننده",
            ERP_updatedAt: "آخرین ویرایش خودگار"
          },
          msg: true
        }
      }
    },
    dis: {
      columns: {
        title: {
          type: "text",
          label: "عنوان تخفیف",
          other: {
            maxLength: 128,
            placeholder: "title"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        type: {
          type: "mrbgSelect",
          label: "برگزیدن نوع",
          firstOptLabel: "برگزیدن نوع",
          optVarName: "disType__ST",
          other: {}
        },
        discountPercent: {
          type: "mrbgNumberInput",
          label: "درصد تخفیف",
          other: {
            placeholder: "discount percent",
            min: 0,
            max: 100
          }
        },
        minPaymentPercent: {
          type: "mrbgNumberInput",
          label: "حداقل درصد پیش پرداخت",
          other: {
            placeholder: "min payment percent",
            min: 0,
            max: 100
          }
        },
        startDate: {
          type: "mrbgPersianDate",
          label: "تاریخ شورع",
          other: {
            maxLength: 32,
            placeholder: "start date"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        endDate: {
          type: "mrbgPersianDate",
          label: "تاریخ پایان",
          other: {
            maxLength: 32,
            placeholder: "end date"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        thresholdAmount: {
          type: "mrbgNumberInput",
          label: "مبلغ کف قیمت @@(تومان)@@",
          other: {
            max: 2147483648,
            min: 0,
            placeholder: "thresholdAmount"
          }
        },
        job: {
          type: "text",
          label: "عنوان شغلی",
          other: {
            maxLength: 128,
            placeholder: "job"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        gender: {
          type: "mrbgRadioInput",
          label: "جنسیت",
          values: "gen__ST",
        },
        id: {
          type: "mrbgSelect",
          label: "برگزیدن تخفیف",
          firstOptLabel: "برگزیدن تخفیف",
          optVarName: "dis__ST"
        },
        startData: {
          type: "mrbgPersianDateTime",
          label: "تاریخ شروع",
          other: []
        },
        createdBy: {
          type: "mrbgSelect",
          label: "ایجاد شده توسط",
          firstOptLabel: "ایجاد شده توسط",
          optVarName: "empUser__ST"
        },
        updatedBy: {
          type: "mrbgSelect",
          label: "آخرین ویرایش توسط",
          firstOptLabel: "آخرین ویرایش توسط",
          optVarName: "empUser__ST"
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ ایجاد",
          other: {
            placeholder: "from"
          }
        },
        updatedAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ به‌روزرسانی",
          other: {
            placeholder: "from"
          }
        }
      },
      forms: {
        dis: {
          title: "ایجاد گروه تخفیف",
          operation: "ins",
          inputs: {
            title: {},
            type: {},
            discountPercent: {},
            minPaymentPercent: {},
            startDate: {},
            endDate: {}
          },
          parts: {
            disPrt: {
              title: "نوع تخفیف",
              inputs: {
                thresholdAmount: {},
                job: {},
                gender: {}
              }
            }
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        }
      },
      tables: {
        dis__TF: {
          tblID: "dis__TB",
          title: "لیست تخفیف‌ها",
          operation: "",
          filters: {
            id: {},
            startData: {},
            endDate: {},
            createdBy: {},
            updatedBy: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: true,
          columns: {
            title: "نام",
            type: "نوع تخفیف",
            discountPercent: "",
            minPaymentPercent: "",
            startDate: "تاریخ شروع",
            endDate: ""
          },
          msg: true
        }
      }
    },
    EWT: {
      columns: {
        empID: {
          type: "mrbgSelect",
          label: "برگزیدن کارمند",
          firstOptLabel: "برگزیدن کارمند",
          optVarName: "emp__ST"
        },
        amount: {
          type: "mrbgNumberInput",
          label: "مبلغ پرداختی @@(تومان)@@",
          other: {
            max: 2147483648,
            min: 0,
            placeholder: "amount"
          }
        },
        apoSesID: {
          type: "mrbgSelect",
          label: "برگزیدن جلسه",
          firstOptLabel: "برگزیدن جلسه",
          optVarName: "apoSes__ST"
        },
        bilPayAmount: {
          type: "mrbgNumberInput",
          label: "مبلغ صورتحساب",
          other: {
            placeholder: "Billed Amount"
          }
        },
        percent: {
          type: "mrbgNumberInput",
          label: "درصد پورسانت",
          other: {
            placeholder: "percent"
          }
        },
        ewtAmount: {
          type: "mrbgNumberInput",
          label: "مبلغ پورسانت",
          other: {
            placeholder: "ewt amount"
          }
        },
        createdBy: {
          type: "mrbgSelect",
          label: "ایجاد شده توسط",
          firstOptLabel: "ایجاد شده توسط",
          optVarName: "empUser__ST"
        },
        updatedBy: {
          type: "mrbgSelect",
          label: "آخرین ویرایش توسط",
          firstOptLabel: "آخرین ویرایش توسط",
          optVarName: "empUser__ST"
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ ایجاد",
          other: {
            placeholder: "from"
          }
        },
        updatedAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ به‌روزرسانی",
          other: {
            placeholder: "from"
          }
        }
      },
      forms: {
        EWT: {
          title: "پرداخت پورسانت به کارمندان",
          operation: "ins",
          inputs: {
            empID: {},
            amount: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        }
      },
      tables: {
        EWT__TF: {
          tblID: "EWT__TB",
          title: "ریز تراکنش ولت کارمندان",
          operation: "",
          filters: {
            empID: {},
            apoSesID: {},
            bilPayAmount: {},
            percent: {},
            ewtAmount: {},
            createdBy: {},
            updatedBy: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: true,
          columns: {
            userName: "نام کارمند",
            apoSesID: "جلسه",
            bilPayAmount: "مبلغ صورت حساب",
            percent: "",
            ewtAmount: "",
            createdBy: "",
            createdAt: "",
            updatedBy: "",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          msg: true
        }
      }
    },
    CWT: {
      columns: {
        cliID: {
          type: "mrbgSelect",
          label: "برگزیدن کارمند",
          firstOptLabel: "برگزیدن کارمند",
          optVarName: "emp__ST"
        },
        apoSesID: {
          type: "mrbgSelect",
          label: "برگزیدن جلسه",
          firstOptLabel: "برگزیدن جلسه",
          optVarName: "apoSes__ST"
        },
        bilPayAmount: {
          type: "mrbgNumberInput",
          label: "مبلغ صورتحساب",
          other: {
            placeholder: "Billed Amount"
          }
        },
        percent: {
          type: "mrbgNumberInput",
          label: "درصد پورسانت",
          other: {
            placeholder: "percent"
          }
        },
        ewtAmount: {
          type: "mrbgNumberInput",
          label: "مبلغ پورسانت",
          other: {
            placeholder: "ewt amount"
          }
        },
        createdBy: {
          type: "mrbgSelect",
          label: "ایجاد شده توسط",
          firstOptLabel: "ایجاد شده توسط",
          optVarName: "empUser__ST"
        },
        updatedBy: {
          type: "mrbgSelect",
          label: "آخرین ویرایش توسط",
          firstOptLabel: "آخرین ویرایش توسط",
          optVarName: "empUser__ST"
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ ایجاد",
          other: {
            placeholder: "from"
          }
        },
        updatedAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ به‌روزرسانی",
          other: {
            placeholder: "from"
          }
        }
      },
      forms: [],
      tables: {
        CWT__TF: {
          tblID: "CWT__TB",
          title: "ریز تراکنش ولت مشتریان",
          operation: "",
          filters: {
            cliID: {},
            apoSesID: {},
            bilPayAmount: {},
            percent: {},
            ewtAmount: {},
            createdBy: {},
            updatedBy: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: true,
          columns: {
            fullName: "نام کامل",
            apoSesID: "جلسه",
            apoPayAmount: "مبلغ پرداخت شده",
            cwtAmount: "تاثیر بر ولت",
            transactionType: "نوع تراکنش",
            createdBy: "",
            createdAt: "",
            updatedBy: "",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          msg: true
        }
      }
    },
    comRul: {
      columns: {
        type: {
          type: "mrbgSelect",
          label: "نوع پورسانت",
          firstOptLabel: "برگزیدن نوع پورسانت",
          optVarName: "comType__ST",
          other: {}
        },
        percent: {
          type: "mrbgNumberInput",
          label: "درصد پورسانت",
          other: {
            placeholder: "commission percent",
            min: 0,
            max: 100
          }
        },
        revenueThreshold: {
          type: "mrbgNumberInput",
          label: "کف درآمد روزانه @@(درآمد روزانه از چند تومان بیشتر بود پورسانت تعلق بگیرد)@@",
          other: {
            max: 4294967295,
            min: 0,
            placeholder: "revenue threshold"
          }
        },
        cap: {
          type: "mrbgNumberInput",
          label: "سقف پورسانت پرداختی @@(تومان)@@",
          other: {
            max: 4294967295,
            min: 0,
            placeholder: "commission cap Toman"
          }
        },
        inactive: {
          type: "mrbgCheckBox",
          label: "غیرفعال",
          other: {
            value: 1
          }
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ ایجاد",
          other: {
            placeholder: "from"
          }
        },
        updatedAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ به‌روزرسانی",
          other: {
            placeholder: "from"
          }
        }
      },
      forms: {
        comRul: {
          title: "تعیین پورسانت‌ها",
          operation: "ins",
          inputs: {
            type: {},
            percent: {},
            revenueThreshold: {},
            cap: {},
            inactive: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        }
      },
      tables: {
        comRul__TF: {
          tblID: "comRul__TB",
          title: "لیست قوانین پورسانت",
          operation: "",
          filters: {
            type: {},
            percent: {},
            revenueThreshold: {},
            cap: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: false,
          columns: {
            type: "نام",
            percent: "درصد",
            revenueThreshold: "آستانه درآمد @@(کف درآمد)@@",
            cap: "بیشینه درآمد @@(سقف درآمد)@@",
            inactive: "",
            createdBy: "ایجاد شده توسط",
            createdAt: "",
            updatedBy: "آخرین ویرایش توسط",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          msg: true
        }
      }
    },
    are: {
      columns: {
        gender: {
          type: "mrbgRadioInput",
          label: "جنسیت",
          values: "gen__ST",
          storeInRedux: true
        },
        parentID: {
          type: "mrbgSelect",
          label: "برگزیدن ناحیه پدر @@(مثلا ران جزو پا است پس ناحیه پدر برای ران می شود پا)@@",
          firstOptLabel: "برگزیدن ناحیه پدر",
          optVarName: "areParent__ST",
          referenceSelect: "gender"
        },
        name: {
          type: "text",
          label: "نام ناحیه",
          other: {
            maxLength: 128,
            placeholder: "Name"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        duration: {
          type: "mrbgNumberInput",
          label: "مدت زمان @@(دقیقه)@@",
          other: {
            placeholder: "Duration Minutes"
          }
        },
        price: {
          type: "mrbgNumberInput",
          label: "بها @@(تومان)@@",
          other: {
            placeholder: "Price Toman"
          }
        },
        requiredSessions: {
          type: "mrbgNumberInput",
          label: "تعداد جلسات مورد نیاز",
          other: {
            placeholder: "required sessions"
          }
        },
        discount: {
          type: "mrbgNumberInput",
          label: "تخفیف @@(تومان)@@",
          other: {
            placeholder: "discount Toman"
          }
        },
        areID: {
          type: "mrbgSelect",
          label: "برگزیدن ناحیه",
          firstOptLabel: "برگزیدن ناحیه",
          optVarName: "are__ST",
          mode: "multi",
          popupObj: {
            id: "areaSelectionFrame",
            icon: "fa-solid fa-user-magnifying-glass"
          }
        },
        id: {
          type: "mrbgSelect",
          label: "برگزیدن ناحیه",
          firstOptLabel: "برگزیدن ناحیه",
          optVarName: "are__ST",
          mode: "multi"
        },
        createdBy: {
          type: "mrbgSelect",
          label: "ایجاد شده توسط",
          firstOptLabel: "ایجاد شده توسط",
          optVarName: "empUser__ST"
        },
        updatedBy: {
          type: "mrbgSelect",
          label: "آخرین ویرایش توسط",
          firstOptLabel: "آخرین ویرایش توسط",
          optVarName: "empUser__ST"
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ ایجاد",
          other: {
            placeholder: "from"
          }
        },
        updatedAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ به‌روزرسانی",
          other: {
            placeholder: "from"
          }
        }
      },
      forms: {
        are: {
          title: "افزودن ناحیه جدید",
          operation: "ins",
          inputs: {
            gender: {},
            name: {},
            parentID: {},
            duration: {},
            price: {},
            requiredSessions: {},
            discount: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        areUpd: {
          title: "ویرایش ناحیه",
          operation: "upd",
          inputs: {
            gender: {},
            name: {},
            duration: {},
            price: {},
            requiredSessions: {},
            discount: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        arePac: {
          title: "افزودن پکیج جدید",
          operation: "insPac",
          inputs: {
            name: {},
            gender: {},
            areID: {},
            duration: {},
            price: {},
            requiredSessions: {},
            discount: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        areSrt: {
          title: "ترتیب نواحی",
          operation: "srt",
          hierarchicalList: "are__SL",
          hierarchicalListMaxDeep: 6,
          inputs: {
            gender: {}
          },
          msg: true,
          btn: {
            label: "change",
            "class": "change"
          }
        }
      },
      tables: {
        are__TF: {
          tblID: "are__TB",
          title: "لیست نواحی",
          operation: "",
          filters: {
            id: {},
            gender: {},
            duration: {},
            price: {},
            requiredSessions: {},
            createdBy: {},
            updatedBy: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: true,
          columns: {
            name: "",
            gender: "",
            duration: "مدت زمان (دقیقه)",
            price: "بها (تومان)",
            requiredSessions: "",
            discount: "تخفیف (تومان)",
            package: "پکیج",
            hasSvgArea: "ناحیه گرافیکی",
            createdBy: "",
            createdAt: "",
            updatedBy: "",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          msg: true
        }
      }
    },
    cli: {
      columns: {
        reagent: {
          type: "mrbgSelect",
          label: "معرف",
          firstOptLabel: "برگزیدن معرف",
          optVarName: "cli__ST"
        },
        percent: {
          type: "mrbgNumberInput",
          label: "درصد پورسانت معرف",
          other: {
            placeholder: "Reagent Percent",
            max: 100,
            min: 0
          }
        },
        fullName: {
          type: "text",
          label: "نام کامل",
          other: {
            maxLength: 128,
            placeholder: "Full Name"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        phone: {
          type: "text",
          label: "شماره تلفن",
          other: {
            maxLength: 14,
            placeholder: "Phone"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        gender: {
          type: "mrbgRadioInput",
          label: "جنسیت",
          values: "gen__ST"
        },
        nationalCode: {
          type: "text",
          label: "کد ملی",
          other: {
            maxLength: 10,
            placeholder: "National Code"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        fatherName: {
          type: "text",
          label: "نام پدر",
          other: {
            maxLength: 128,
            placeholder: "Father Name"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        birthday: {
          type: "mrbgPersianDate",
          label: "تاریخ تولد",
          other: {
            placeholder: "Birthday"
          }
        },
        job: {
          type: "text",
          label: "شغل",
          other: {
            maxLength: 128,
            placeholder: "Job"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        address: {
          type: "text",
          label: "آدرس",
          other: {
            maxLength: 1024,
            placeholder: "Address"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        diseases: {
          type: "text",
          label: "نام بیماری",
          other: {
            maxLength: 128,
            placeholder: "Diseases"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        medication: {
          type: "text",
          label: "نام داروها @@(داروی اول، داروی دوم، ...)@@",
          other: {
            maxLength: 128,
            placeholder: "Medication"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        id: {
          type: "mrbgSelect",
          label: "نام کامل",
          firstOptLabel: "برگزیدن نام کامل",
          optVarName: "cli__ST"
        },
        illness: {
          type: "text",
          label: "نام بیماری",
          other: {
            maxLength: 128,
            placeholder: "Illness Name"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        createdBy: {
          type: "mrbgSelect",
          label: "ایجاد شده توسط",
          firstOptLabel: "ایجاد شده توسط",
          optVarName: "empUser__ST"
        },
        updatedBy: {
          type: "mrbgSelect",
          label: "آخرین ویرایش توسط",
          firstOptLabel: "آخرین ویرایش توسط",
          optVarName: "empUser__ST"
        },
        walletBalance: {
          type: "mrbgNumberInput",
          label: "موجودی کیف پول",
          other: {
            placeholder: "from"
          }
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ ایجاد",
          other: {
            placeholder: "from"
          }
        },
        updatedAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ به‌روزرسانی",
          other: {
            placeholder: "from"
          }
        }
      },
      forms: {
        cli: {
          title: "افزودن مشتری جدید",
          operation: "ins",
          inputs: {
            reagent: {},
            percent: {},
            fullName: {},
            phone: {},
            gender: {},
            nationalCode: {},
            fatherName: {},
            birthday: {},
            job: {},
            address: {}
          },
          parts: {
            disPrt: {
              subTitle: "سابقه بیماری/داروی خاص",
              repeat: 1,
              inputs: {
                diseases: {},
                medication: {}
              }
            }
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        }
      },
      tables: {
        cli__TF: {
          tblID: "cli__TB",
          title: "لیست مشتریان",
          operation: "",
          filters: {
            id: {},
            nationalCode: {},
            phone: {},
            gender: {},
            job: {},
            illness: {},
            reagent: {},
            createdBy: {},
            updatedBy: {},
            birthday: {},
            walletBalance: {},
            createdAt: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: true,
          columns: {
            reagent: "",
            percent: "",
            fullName: "",
            fatherName: "",
            nationalCode: "",
            phone: "",
            birthday: "",
            gender: "",
            job: "",
            address: "",
            diseases: "بیماری خاص",
            medication: "داروهای خاص",
            walletBalance: "",
            createdBy: "",
            createdAt: "",
            updatedBy: "",
            updatedAt: "تاریخ آخرین ویرایش"
          },
          component: {
            phone: "phone",
          },
          msg: true
        }
      }
    },
    emp: {
      columns: {
        id: {
          type: "mrbgSelect",
          label: "برگزیدن کارمند",
          firstOptLabel: "برگزیدن کارمند",
          optVarName: "emp__ST"
        },
        userName: {
          type: "text",
          label: "نام کاربری",
          other: {
            maxLength: 128,
            placeholder: "user name"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        type: {
          type: "mrbgSelect",
          label: "برگزیدن نوع",
          firstOptLabel: "برگزیدن نوع",
          optVarName: "empType__ST"
        },
        phone: {
          type: "tel",
          label: "شماره تلفن",
          other: {
            maxLength: 32,
            placeholder: "mobile"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        mail: {
          type: "email",
          label: "ایمیل",
          other: {
            maxLength: 128,
            placeholder: "mail"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        gender: {
          type: "mrbgRadioInput",
          label: "جنسیت",
          values: "gen__ST"
        },
        salary: {
          type: "mrbgNumberInput",
          label: "دستمزد @@(تومان)@@",
          other: {
            max: 4294967295,
            min: 0,
            placeholder: "salary"
          }
        },
        birthday: {
          type: "mrbgPersianDate",
          label: "تاریخ تولد",
          other: {
            maxLength: 32,
            placeholder: "user name"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        beginContract: {
          type: "mrbgPersianDate",
          label: "تاریخ آغاز قرارداد",
          other: {
            placeholder: "begin contract"
          }
        },
        endContract: {
          type: "mrbgPersianDate",
          label: "تاریخ پایان قرارداد",
          other: {
            placeholder: "end contract"
          }
        },
        devID: {
          type: "mrbgSelect",
          label: "برگزیدن دستگاه",
          firstOptLabel: "برگزیدن دستگاه",
          optVarName: "dev__ST",
          mode: "multi"
        },
        disable: {
          type: "mrbgCheckBox",
          label: "غیرفعال کردن",
          other: {
            value: 1
          }
        },
        pagStore: {
          type: "mrbgCheckBox",
          label: "افزودن",
          other: {
            value: "1"
          }
        },
        pagEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش",
          other: {
            value: "1"
          }
        },
        pagRemove: {
          type: "mrbgCheckBox",
          label: "پاک کردن",
          other: {
            value: "1"
          }
        },
        hedLinStore: {
          type: "mrbgCheckBox",
          label: "افزودن",
          other: {
            value: "1"
          }
        },
        hedLinEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش",
          other: {
            value: "1"
          }
        },
        hedLinSort: {
          type: "mrbgCheckBox",
          label: "تغییر چیدمان",
          other: {
            value: "1"
          }
        },
        hedLinRemove: {
          type: "mrbgCheckBox",
          label: "پاک کردن",
          other: {
            value: "1"
          }
        },
        sldStore: {
          type: "mrbgCheckBox",
          label: "افزودن",
          other: {
            value: "1"
          }
        },
        sldEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش",
          other: {
            value: "1"
          }
        },
        sldRemove: {
          type: "mrbgCheckBox",
          label: "پاک کردن",
          other: {
            value: "1"
          }
        },
        conStore: {
          type: "mrbgCheckBox",
          label: "افزودن",
          other: {
            value: "1"
          }
        },
        conEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش",
          other: {
            value: "1"
          }
        },
        conRemove: {
          type: "mrbgCheckBox",
          label: "پاک کردن",
          other: {
            value: "1"
          }
        },
        ourTemStore: {
          type: "mrbgCheckBox",
          label: "افزودن",
          other: {
            value: "1"
          }
        },
        ourTemEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش",
          other: {
            value: "1"
          }
        },
        ourTemRemove: {
          type: "mrbgCheckBox",
          label: "پاک کردن",
          other: {
            value: "1"
          }
        },
        fotStore: {
          type: "mrbgCheckBox",
          label: "افزودن",
          other: {
            value: "1"
          }
        },
        apoResStore: {
          type: "mrbgCheckBox",
          label: "افزودن نوبت",
          other: {
            value: "1"
          }
        },
        apoResEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش نوبت",
          other: {
            value: "1"
          }
        },
        apoSesFix: {
          type: "mrbgCheckBox",
          label: "فیکس کردن نوبت",
          other: {
            value: "1"
          }
        },
        apoSesActive: {
          type: "mrbgCheckBox",
          label: "اکتیو کردن نوبت",
          other: {
            value: "1"
          }
        },
        apoSesFinish: {
          type: "mrbgCheckBox",
          label: "اعلام پایان نوبت @@(مخصوص اپراتورها)@@",
          other: {
            value: "1"
          }
        },
        FUAStore: {
          type: "mrbgCheckBox",
          label: "افزودن پیگیری",
          other: {
            value: "1"
          }
        },
        FUAEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش پیگیری",
          other: {
            value: "1"
          }
        },
        FUARemove: {
          type: "mrbgCheckBox",
          label: "پاک کردن پیگیری",
          other: {
            value: "1"
          }
        },
        appointmentStatistics: {
          type: "mrbgCheckBox",
          label: "نمودارهای مربوط نوبت",
          other: {
            value: "1"
          }
        },
        financialStatistics: {
          type: "mrbgCheckBox",
          label: "نمودارهای مالی",
          other: {
            value: "1"
          }
        },
        revenuesStore: {
          type: "mrbgCheckBox",
          label: "ثبت درآمدها @@(به جز نوبت)@@",
          other: {
            value: "1"
          }
        },
        revenuesEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش درآمدها @@(به جز نوبت)@@",
          other: {
            value: "1"
          }
        },
        expensesStore: {
          type: "mrbgCheckBox",
          label: "ثبت هزینه‌ها",
          other: {
            value: "1"
          }
        },
        expensesEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش هزینه‌ها",
          other: {
            value: "1"
          }
        },
        bilRevoke: {
          type: "mrbgCheckBox",
          label: "ابطال صورت حساب",
          other: {
            value: "1"
          }
        },
        bilPay: {
          type: "mrbgCheckBox",
          label: "پرداخت صورت حساب",
          other: {
            value: "1"
          }
        },
        cardConfirm: {
          type: "mrbgCheckBox",
          label: "تایید کارت به کارت",
          other: {
            value: "1"
          }
        },
        EWT_view: {
          type: "mrbgCheckBox",
          label: "ریز تراکنش پورسانت کارمندان",
          other: {
            value: "1"
          }
        },
        EWTStore: {
          type: "mrbgCheckBox",
          label: "ثبت پرداخت پورسانت کارمندان",
          other: {
            value: "1"
          }
        },
        funStore: {
          type: "mrbgCheckBox",
          label: "ایجاد حساب بانکی / صندوق نقدی",
          other: {
            value: "1"
          }
        },
        funEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش حساب بانکی / صندوق نقدی",
          other: {
            value: "1"
          }
        },
        funRemove: {
          type: "mrbgCheckBox",
          label: "پاک کردن حساب بانکی / صندوق نقدی",
          other: {
            value: "1"
          }
        },
        disStore: {
          type: "mrbgCheckBox",
          label: "ایجاد تخفیف",
          other: {
            value: "1"
          }
        },
        disEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش تخفیف",
          other: {
            value: "1"
          }
        },
        disRemove: {
          type: "mrbgCheckBox",
          label: "پاک کردن تخفیف",
          other: {
            value: "1"
          }
        },
        cliStore: {
          type: "mrbgCheckBox",
          label: "ایحاد پرونده جدید @@(مشتری جدید)@@",
          other: {
            value: "1"
          }
        },
        cliEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش پرونده‌ها",
          other: {
            value: "1"
          }
        },
        cliRemove: {
          type: "mrbgCheckBox",
          label: "پاک کردن پرونده",
          other: {
            value: "1"
          }
        },
        CWT_view: {
          type: "mrbgCheckBox",
          label: "ریز تراکنش ولت مشتریان",
          other: {
            value: "1"
          }
        },
        areStore: {
          type: "mrbgCheckBox",
          label: "افزودن",
          other: {
            value: "1"
          }
        },
        areEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش",
          other: {
            value: "1"
          }
        },
        areRemove: {
          type: "mrbgCheckBox",
          label: "پاک کردن",
          other: {
            value: "1"
          }
        },
        areSort: {
          type: "mrbgCheckBox",
          label: "تغییر چیدمان",
          other: {
            value: "1"
          }
        },
        empStore: {
          type: "mrbgCheckBox",
          label: "افزودن",
          other: {
            value: "1"
          }
        },
        empEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش",
          other: {
            value: "1"
          }
        },
        empRemove: {
          type: "mrbgCheckBox",
          label: "پاک کردن",
          other: {
            value: "1"
          }
        },
        comRulStore: {
          type: "mrbgCheckBox",
          label: "افزودن قانون پورسانت",
          other: {
            value: "1"
          }
        },
        comRulEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش قانون پورسانت",
          other: {
            value: "1"
          }
        },
        comRulRemove: {
          type: "mrbgCheckBox",
          label: "پاک کردن قانون پورسانت",
          other: {
            value: "1"
          }
        },
        devStore: {
          type: "mrbgCheckBox",
          label: "افزودن دستگاه",
          other: {
            value: "1"
          }
        },
        devEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش دستگاه",
          other: {
            value: "1"
          }
        },
        devRemove: {
          type: "mrbgCheckBox",
          label: "جذف دستگاه",
          other: {
            value: "1"
          }
        },
        entStore: {
          type: "mrbgCheckBox",
          label: "ایجاد مواد مصرفی",
          other: {
            value: "1"
          }
        },
        entEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش مواد مصرفی",
          other: {
            value: "1"
          }
        },
        entRemove: {
          type: "mrbgCheckBox",
          label: "پاک کردن مواد مصرفی",
          other: {
            value: "1"
          }
        },
        worHorEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش ساعات کاری",
          other: {
            value: "1"
          }
        },
        worShfStore: {
          type: "mrbgCheckBox",
          label: "افزودن شیفت کاری",
          other: {
            value: "1"
          }
        },
        worShfEdit: {
          type: "mrbgCheckBox",
          label: "ویرایش شیفت کاری",
          other: {
            value: "1"
          }
        },
        worShfRemove: {
          type: "mrbgCheckBox",
          label: "پاک کردن شیفت کاری",
          other: {
            value: "1"
          }
        },
        oldPass: {
          type: "password",
          label: "گذرواژه پیشین",
          other: [],
          fldAttr: {
            className: [
              "mrgbViewPass"
            ]
          }
        },
        newPass: {
          type: "password",
          label: "گذرواژه جدید",
          other: [],
          fldAttr: {
            className: [
              "mrgbViewPass"
            ]
          }
        },
        img: {
          type: "mrbgImgFile",
          label: "برگزیدن عکس",
          other: {
            placeholder: "image",
            accept: "image/bmp,image/gif,image/jpeg,image/pjpeg,image/png,image/webp",
            "data-height": 400,
            "data-width": 400
          },
          fldAttr: {}
        },
        createdBy: {
          type: "mrbgSelect",
          label: "نگارنده",
          firstOptLabel: "برگزیدن کارمند",
          optVarName: "empUser__ST"
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ ایجاد",
          other: {
            placeholder: "from"
          }
        },
        updatedBy: {
          type: "mrbgSelect",
          label: "ویرایشگر",
          firstOptLabel: "برگزیدن کارمند",
          optVarName: "empUser__ST"
        },
        updatedAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ به‌روزرسانی",
          other: {
            placeholder: "from"
          }
        }
      },
      forms: {
        emp: {
          title: "ایجاد کارمند جدید",
          operation: "ins",
          inputs: {
            userName: {},
            type: {},
            phone: {},
            mail: {},
            gender: {},
            salary: {},
            birthday: {},
            beginContract: {},
            endContract: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        empUpd: {
          title: "به‌روزرسانی کارمند",
          operation: "upd",
          inputs: {
            id: {},
            userName: {},
            type: {},
            phone: {},
            mail: {},
            gender: {},
            salary: {},
            birthday: {},
            beginContract: {},
            endContract: {},
            devID: {},
            disable: {}
          },
          parts: {
            pagPat: {
              title: "مدیریت صفحات",
              repeat: 1,
              inputs: {
                pagStore: {},
                pagEdit: {},
                pagRemove: {}
              }
            },
            hedLinPat: {
              title: "مدیریت هدر",
              repeat: 1,
              inputs: {
                hedLinStore: {},
                hedLinEdit: {},
                hedLinSort: {},
                hedLinRemove: {}
              }
            },
            sldPat: {
              title: "مدیریت اسلایدر",
              repeat: 1,
              inputs: {
                sldStore: {},
                sldEdit: {},
                sldRemove: {}
              }
            },
            conPat: {
              title: "مدیریت محتوا",
              repeat: 1,
              inputs: {
                conStore: {},
                conEdit: {},
                conRemove: {}
              }
            },
            ourTemPat: {
              title: "مدیریت تیم ما",
              repeat: 1,
              inputs: {
                ourTemStore: {},
                ourTemEdit: {},
                ourTemRemove: {}
              }
            },
            fotPat: {
              title: "مدیریت فوتر",
              repeat: 1,
              inputs: {
                fotStore: {}
              }
            },
            apoPat: {
              title: "مدیریت نوبت‌ها",
              repeat: 1,
              inputs: {
                apoResStore: {},
                apoResEdit: {},
                apoSesFix: {},
                apoSesActive: {},
                apoSesFinish: {},
                FUAStore: {},
                FUAEdit: {},
                FUARemove: {},
                appointmentStatistics: {},
                financialStatistics: {}
              }
            },
            bilPat: {
              title: "صورت حساب‌ها",
              repeat: 1,
              inputs: {
                revenuesStore: {},
                revenuesEdit: {},
                expensesStore: {},
                expensesEdit: {},
                bilRevoke: {},
                bilPay: {},
                cardConfirm: {}
              }
            },
            finPat: {
              title: "مدیریت مالی",
              repeat: 1,
              inputs: {
                EWT_view: {},
                EWTStore: {},
                funStore: {},
                funEdit: {},
                funRemove: {},
                disStore: {},
                disEdit: {},
                disRemove: {}
              }
            },
            cliPat: {
              title: "مدیریت پرونده‌ها",
              repeat: 1,
              inputs: {
                cliStore: {},
                cliEdit: {},
                cliRemove: {},
                CWT_view: {}
              }
            },
            arePat: {
              title: "ناحیه‌ها",
              repeat: 1,
              inputs: {
                areStore: {},
                areEdit: {},
                areRemove: {},
                areSort: {}
              }
            },
            empPat: {
              title: "کارمندان",
              repeat: 1,
              inputs: {
                empStore: {},
                empEdit: {},
                empRemove: {}
              }
            },
            basPat: {
              title: "اطلاعات پایه",
              repeat: 1,
              inputs: {
                comRulStore: {},
                comRulEdit: {},
                comRulRemove: {},
                devStore: {},
                devEdit: {},
                devRemove: {},
                entStore: {},
                entEdit: {},
                entRemove: {},
                worHorEdit: {},
                worShfStore: {},
                worShfEdit: {},
                worShfRemove: {}
              }
            }
          },
          keys__FF: [
            "id"
          ],
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        empPass: {
          title: "به‌روزرسانی گذرواژه",
          operation: "chP",
          inputs: {
            oldPass: {},
            newPass: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        empAvt: {
          title: "ویرایش عکس پروفایل",
          operation: "avt",
          inputs: {
            img: {}
          },
          msg: true,
          btn: {
            label: "upload",
            "class": "upload"
          }
        }
      },
      tables: {
        emp__TF: {
          tblID: "emp__TB",
          title: "لیست کارمندان",
          operation: "",
          filters: {
            id: {},
            type: {},
            phone: {},
            gender: {},
            salary: {},
            birthday: {},
            beginContract: {},
            endContract: {},
            createdBy: {},
            createdAt: {},
            updatedBy: {},
            updatedAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: true,
          columns: {
            img: "آواتار",
            userName: "نام",
            type: "نوع کارمند",
            phone: "شماره",
            mail: "",
            gender: "",
            salary: "دستمزد",
            birthday: "تولد",
            beginContract: "آغاز قرارداد",
            endContract: "پایان قرارداد",
            walletBalance: "موجودی پورسانت",
            devName: "دستگاه",
            disable: "غیرفعال",
            کارمندان: {
              empStore: "افزودن",
              empEdit: "به‌روزرسانی",
              empRemove: "حذف"
            },
            "نوبت دهی": {
              apoResStore: "رزرو نوبت",
              apoResEdit: "به‌روزرسانی نوبت",
              apoSesFix: "قیکس کردن نوبت",
              apoSesActive: "اکتیو کردن نوبت",
              apoSesFinish: "اعلام پایان نوبت",
              appointmentStatistics: "نمودارهای نوبت",
              financialStatistics: "نمودارهای مالی"
            },
            مالی: {
              revenuesStore: "ثبت درآمدها",
              revenuesEdit: "ویرایش درآمدها",
              expensesStore: "ثبت هزینه‌ها",
              expensesEdit: "ویرایش هزینه‌ها",
              bilRevoke: "ابطال صورت حساب",
              bilPay: "پرداخت صورت حساب",
              cardConfirm: "تایید کارت به کارت",
              CWT_view: "ریز تراکنش پرداخت مشتریان",
              EWTStore: "ثبت پرداخت پورسانت",
              EWT_view: "زیر تراکنش پورسانت کارمندان"
            },
            نواحی: {
              areStore: "افزودن",
              areEdit: "به‌روزرسانی",
              areRemove: "حذف",
              areSort: "تغییر چیدمان"
            },
            تخفیف‌ها: {
              disStore: "افزودن",
              disEdit: "به‌روزرسانی",
              disRemove: "حذف"
            },
            مشتری‌ها: {
              cliStore: "افزودن",
              cliEdit: "به‌روزرسانی",
              cliRemove: "حذف"
            },
            "قوانین پورسانت": {
              comRulStore: "افزودن",
              comRulEdit: "به‌روزرسانی",
              comRulRemove: "حذف"
            },
            پیگیری‌ها: {
              FUAStore: "افزودن",
              FUAEdit: "به‌روزرسانی",
              FUARemove: "حذف"
            },
            "مواد مصرفی": {
              entStore: "افزودن",
              entEdit: "به‌روزرسانی",
              entRemove: "حذف"
            },
            دستگاه: {
              devStore: "افزودن",
              devEdit: "به‌روزرسانی",
              devRemove: "حذف"
            },
            worHorEdit: "بروزرسانی ساعات کاری",
            محتوا: {
              conStore: "افزودن",
              conEdit: "به‌روزرسانی",
              conRemove: "حذف"
            },
            فوتر: {
              fotStore: "افزودن و به‌روزرسانی"
            },
            "لینک‌های هدر": {
              hedLinStore: "افزودن",
              hedLinEdit: "به‌روزرسانی",
              hedLinRemove: "حذف",
              hedLinSort: "ترتیب"
            },
            "تیم ما": {
              ourTemStore: "افزودن",
              ourTemEdit: "به‌روزرسانی",
              ourTemRemove: "حذف"
            },
            صفحات: {
              pagStore: "افزودن",
              pagEdit: "به‌روزرسانی",
              pagRemove: "حذف"
            },
            اسلایدر: {
              sldStore: "افزودن",
              sldEdit: "به‌روزرسانی",
              sldRemove: "حذف"
            },
            "داده‌های کارمند": {
              createdBy: "ایجاد شده توسط",
              createdAt: "تاریخ ایجاد",
              updatedBy: "آخرین ویرایش توسط",
              updatedAt: "تاریخ آخرین ویرایش"
            },
            "درسترسی‌های کارمند": {
              acsUpdatedBy: "آخرین ویرایش توسط",
              acsUpdatedAt: "تاریخ آخرین ویرایش"
            }
          },
          msg: true
        }
      }
    },
    dev: {
      columns: {
        name: {
          type: "text",
          label: "نام دستگاه",
          other: {
            maxLength: 128,
            placeholder: "device name"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        deactivate: {
          type: "mrbgCheckBox",
          label: "غیرفعال کردن دستگاه",
          other: {
            value: 1
          },
          fldAttr: {}
        },
        id: {
          type: "mrbgSelect",
          label: "برگزیدن دستگاه",
          firstOptLabel: "برگزیدن دستگاه",
          optVarName: "dev__ST"
        },
        createdBy: {
          type: "mrbgSelect",
          label: "نگارنده",
          firstOptLabel: "برگزیدن کارمند",
          optVarName: "empUser__ST"
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ ایجاد",
          other: {
            placeholder: "from"
          }
        }
      },
      forms: {
        dev: {
          title: "ثبت دستگاه‌ها",
          operation: "ins",
          inputs: {
            name: {},
            deactivate: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        }
      },
      tables: {
        dev__TF: {
          tblID: "dev__TB",
          title: "لیست دستگاه‌ها",
          operation: "",
          filters: {
            id: {},
            createdBy: {},
            createdAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: true,
          columns: {
            name: "",
            deactivate: "غیرفعال",
            createdBy: "ایجاد شده توسط",
            createdAt: "",
            updatedBy: "آخرین ویرایشگر",
            updatedAt: "زمان آخرین ویرایش"
          },
          msg: true
        }
      }
    },
    ent: {
      columns: {
        name: {
          type: "text",
          label: "نام ماده مصرفی",
          other: {
            maxLength: 128,
            placeholder: "entities name"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        entID: {
          type: "mrbgSelect",
          label: "برگزیدن ماده مصرفی",
          firstOptLabel: "برگزیدن ماده مصرفی",
          optVarName: "ent__ST"
        },
        quantity: {
          type: "mrbgNumberInput",
          label: "تعداد",
          other: {
            max: 32768,
            min: 1,
            placeholder: "quantity"
          }
        },
        purchasePrice: {
          type: "mrbgNumberInput",
          label: "بهای خرید",
          other: {
            max: 2147483648,
            min: 0,
            placeholder: "purchase price"
          }
        },
        sellingPrice: {
          type: "mrbgNumberInput",
          label: "بهای قروش",
          other: {
            max: 2147483648,
            min: 0,
            placeholder: "sells price"
          }
        },
        id: {
          type: "mrbgSelect",
          label: "برگزیدن ماده مصرفی",
          firstOptLabel: "برگزیدن ماده مصرفی",
          optVarName: "ent__ST"
        },
        createdBy: {
          type: "mrbgSelect",
          label: "نگارنده",
          firstOptLabel: "برگزیدن کارمند",
          optVarName: "empUser__ST"
        },
        createdAt: {
          type: "mrbgPersianDateTime",
          label: "تاریخ ایجاد",
          other: {
            placeholder: "from"
          }
        }
      },
      forms: {
        ent: {
          title: "ثبت مواد مصرفی",
          operation: "ins",
          inputs: {
            name: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        },
        entInv: {
          title: "موجودی مواد مصرفی",
          operation: "add",
          inputs: {
            entID: {},
            quantity: {},
            purchasePrice: {},
            sellingPrice: {}
          },
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        }
      },
      tables: {
        ent__TF: {
          tblID: "ent__TB",
          title: "لیست مواد مصرفی",
          operation: "",
          filters: {
            id: {},
            createdBy: {},
            createdAt: {}
          },
          rowsCol: true,
          pencil: true,
          trash: true,
          columns: {
            name: "",
            inventory: "موجودی",
            purchasePrice: "",
            sellingPrice: "بهای فروش",
            createdBy: "ایجاد شده توسط",
            createdAt: "",
            updatedBy: "آخرین ویرایشگر",
            updatedAt: "زمان آخرین ویرایش"
          },
          msg: true
        }
      }
    },
    worHor: {
      columns: {
        id: {
          type: "mrbgSelect",
          label: "برگزیدن روز",
          firstOptLabel: "برگزیدن روز",
          optVarName: "worHor__ST",
          fldAttr: {
            className: []
          }
        },
        begin: {
          type: "time",
          label: "ساعت آغاز کار",
          other: {
            placeholder: "begin"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        end: {
          type: "time",
          label: "ساعت پایان کار",
          other: {
            placeholder: "end"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        beginRest: {
          type: "time",
          label: "ساعت آغاز استراحت",
          other: {
            placeholder: "begin rest"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        endRest: {
          type: "time",
          label: "ساعت پایان استراحت",
          other: {
            placeholder: "end rest"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        holiday: {
          type: "mrbgCheckBox",
          label: "تعطیل",
          other: {
            value: 1
          },
          fldAttr: {
            className: []
          }
        }
      },
      forms: {
        worHor: {
          title: "تعریف ساعت کاری روزهای هفته",
          operation: "upd",
          inputs: {
            id: {},
            begin: {},
            end: {},
            beginRest: {},
            endRest: {},
            holiday: {}
          },
          keys__FF: [
            "id"
          ],
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        }
      },
      tables: {
        worHor__TF: {
          tblID: "worHor__TB",
          title: "لیست ساعت کاری روزهای هفته",
          operation: "",
          filters: {
            id: {},
            begin: {},
            end: {},
            beginRest: {},
            endRest: {},
            holiday: {}
          },
          rowsCol: true,
          pencil: true,
          trash: false,
          columns: {
            persian: "روز",
            begin: "",
            end: "",
            beginRest: "",
            endRest: "",
            holiday: "",
            updatedBy: "آخرین ویرایشگر",
            updatedAt: "زمان آخرین ویرایش"
          },
          msg: true
        }
      }
    },
    worShf: {
      columns: {
        latin: {
          type: "mrbgSelect",
          label: "برگزیدن روز",
          firstOptLabel: "برگزیدن روز",
          optVarName: "day__ST",
          fldAttr: {
            className: []
          }
        },
        "name[0]": {
          type: "hidden",
          other: {
            value: "شیفت صبح"
          }
        },
        "startTime[0]": {
          type: "time",
          label: "ساعت آغاز",
          other: {
            placeholder: "start time"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        "endTime[0]": {
          type: "time",
          label: "ساعت پایان",
          other: {
            placeholder: "end time"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        "name[1]": {
          type: "hidden",
          other: {
            value: "شیفت عصر"
          }
        },
        "startTime[1]": {
          type: "time",
          label: "ساعت آغاز",
          other: {
            placeholder: "start time"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        "endTime[1]": {
          type: "time",
          label: "ساعت پایان",
          other: {
            placeholder: "end time"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        "name[2]": {
          type: "hidden",
          other: {
            value: "شیفت شب"
          }
        },
        "startTime[2]": {
          type: "time",
          label: "ساعت آغاز",
          other: {
            placeholder: "start time"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        "endTime[2]": {
          type: "time",
          label: "ساعت پایان",
          other: {
            placeholder: "end time"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        startTime: {
          type: "time",
          label: "ساعت آغاز",
          other: {
            placeholder: "begin rest"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        },
        endTime: {
          type: "time",
          label: "ساعت پایان",
          other: {
            placeholder: "end rest"
          },
          fldAttr: {
            className: [
              "mrbgVoice"
            ]
          }
        }
      },
      forms: {
        worShf: {
          title: "تعریف شیفت کاری @@(هر شیفت که نیاز است را پر کنید)@@",
          operation: "ins",
          inputs: {
            latin: {}
          },
          parts: {
            morningPat: {
              title: "شیفت صبح",
              inputs: {
                "name[0]": {},
                "startTime[0]": {},
                "endTime[0]": {}
              }
            },
            eveningPat: {
              title: "شیفت عصر",
              inputs: {
                "name[1]": {},
                "startTime[1]": {},
                "endTime[1]": {}
              }
            },
            nightPat: {
              title: "شیفت شب",
              inputs: {
                "name[2]": {},
                "startTime[2]": {},
                "endTime[2]": {}
              }
            }
          },
          keys__FF: [
            "latin"
          ],
          msg: true,
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        }
      },
      tables: {
        worShf__TF: {
          tblID: "worShf__TB",
          title: "لیست شیفت‌های کاری",
          operation: "",
          filters: {
            latin: {},
            startTime: {},
            endTime: {}
          },
          rowsCol: true,
          pencil: true,
          trash: true,
          columns: {
            persian: "روز",
            name: "نام شیفت",
            startTime: "",
            endTime: "",
            createdBy: "ایجاد شده توسط",
            createdAt: "تاریخ ایجاد",
            updatedBy: "آخرین ویرایشگر",
            updatedAt: "زمان آخرین ویرایش"
          },
          msg: true
        }
      }
    },
    EPF: {
      columns: {
        beginDateTime: {
          type: "mrbgPersianDate",
          label: "از تاریخ",
          other: {
            placeholder: "from Datetime"
          }
        }
      },
      forms: {
        exlPdfExp: {
          title: "دریافت فایل اکسل و pdf",
          operation: "exp",
          blobResponse: true,
          msg: true,
          inputs: {
            beginDateTime__0: {},
            beginDateTime__1: {}
          },
          btn: {
            label: "confirm",
            "class": "confirm"
          }
        }
      },
      tables: []
    },
    exl: {
      columns: {
        exlFile: {
          type: "file",
          label: "برگزیدن فایل",
          other: {
            placeholder: "excel file",
            accept: ".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          },
          fldAttr: {}
        }
      },
      forms: {
        excelImp: {
          title: "آپلود بک آپ @@(با آپلود بگ آپ تمام اطلاعات پاک می شود و اطلاعات بک آپ جایگرین آنها می شوند.)@@",
          operation: "imp",
          blobResponse: true,
          inputs: {
            exlFile: {}
          },
          msg: true,
          btn: {
            label: "upload",
            "class": "upload"
          }
        }
      },
      tables: []
    }
  }
}